












































































































































import TheManualConfirm from '@/components/order/mixins/ManualConfirm';
import {Component, Mixins} from 'vue-property-decorator';

@Component({
  components: {}
})
export default class ManualConfirm extends Mixins(TheManualConfirm) {
  private created(): void {
    this.checkSucessOrNot();
    this.getMessage();
  }
  private mounted(): void {}
  private distroyed(): void {}
}
